// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@plumberssupply/XDL/types";

import DatePickerPresentationPropsDefault from "@plumberssupply/MobiusOverrides/DatePicker/presentationProps";
import { color } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

export const chevronRightString =
    "PCEtLSBYTkdBR0UgQ09ORklERU5USUFMIC0tPg0KPCEtLSBfX19fX19fX19fX19fX19fX19fX19fX19fXyAtLT4NCjwhLS0gLS0+DQo8IS0tIENvcHlyaWdodCAoQykgMjAyMiBYbmdhZ2UgLSBBbGwgUmlnaHRzIFJlc2VydmVkIC0tPg0KPCEtLSAtLT4NCjwhLS0gQWxsIGNvZGUgb3IgaW5mb3JtYXRpb24gY29udGFpbmVkIGhlcmVpbiBpcywgYW5kIHJlbWFpbnMgdGhlIC0tPg0KPCEtLSBwcm9wZXJ0eSBvZiBYbmdhZ2UgTExDIGFuZCBpdHMgY3VzdG9tZXJzLiAgVGhlIGludGVsbGVjdHVhbCAtLT4NCjwhLS0gYW5kIHRlY2huaWNhbCBjb25jZXB0cyBjb250YWluZWQgYXJlIHByb3ByaWV0YXJ5IHRvIFhuZ2FnZSBMTEMgLS0+DQo8IS0tIGFuZCBtYXkgYmUgY292ZXJlZCBieSBVLlMuIGFuZCBGb3JlaWduIFBhdGVudHMsIHBhdGVudHMgaW4gLS0+DQo8IS0tIHByb2Nlc3MsIGFuZCBhcmUgcHJvdGVjdGVkIGJ5IHRyYWRlIHNlY3JldCBvciBjb3B5cmlnaHQgbGF3LiAtLT4NCjwhLS0gRGlzc2VtaW5hdGlvbiBvZiB0aGlzIGluZm9ybWF0aW9uIG9yIHJlcHJvZHVjdGlvbiBvZiB0aGlzIG1hdGVyaWFsIC0tPg0KPCEtLSBpcyBzdHJpY3RseSBmb3JiaWRkZW4gdW5sZXNzIHByaW9yIHdyaXR0ZW4gcGVybWlzc2lvbiBpcyBvYnRhaW5lZCAtLT4NCjwhLS0gZnJvbSBYbmdhZ2UgTExDLiAtLT4NCjwhLS0gLS0+DQoNCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Im0yNy41IDAtMi4zIDIuMyA4LjA3IDguMDdIMHYzLjI2aDMzLjI3TDI1LjIgMjEuN2wyLjMgMi4zIDEyLTEyeiIvPjwvc3ZnPg==";

export const chevronLeftString =
    "PCEtLSBYTkdBR0UgQ09ORklERU5USUFMIC0tPg0KPCEtLSBfX19fX19fX19fX19fX19fX19fX19fX19fXyAtLT4NCjwhLS0gLS0+DQo8IS0tIENvcHlyaWdodCAoQykgMjAyMiBYbmdhZ2UgLSBBbGwgUmlnaHRzIFJlc2VydmVkIC0tPg0KPCEtLSAtLT4NCjwhLS0gQWxsIGNvZGUgb3IgaW5mb3JtYXRpb24gY29udGFpbmVkIGhlcmVpbiBpcywgYW5kIHJlbWFpbnMgdGhlIC0tPg0KPCEtLSBwcm9wZXJ0eSBvZiBYbmdhZ2UgTExDIGFuZCBpdHMgY3VzdG9tZXJzLiAgVGhlIGludGVsbGVjdHVhbCAtLT4NCjwhLS0gYW5kIHRlY2huaWNhbCBjb25jZXB0cyBjb250YWluZWQgYXJlIHByb3ByaWV0YXJ5IHRvIFhuZ2FnZSBMTEMgLS0+DQo8IS0tIGFuZCBtYXkgYmUgY292ZXJlZCBieSBVLlMuIGFuZCBGb3JlaWduIFBhdGVudHMsIHBhdGVudHMgaW4gLS0+DQo8IS0tIHByb2Nlc3MsIGFuZCBhcmUgcHJvdGVjdGVkIGJ5IHRyYWRlIHNlY3JldCBvciBjb3B5cmlnaHQgbGF3LiAtLT4NCjwhLS0gRGlzc2VtaW5hdGlvbiBvZiB0aGlzIGluZm9ybWF0aW9uIG9yIHJlcHJvZHVjdGlvbiBvZiB0aGlzIG1hdGVyaWFsIC0tPg0KPCEtLSBpcyBzdHJpY3RseSBmb3JiaWRkZW4gdW5sZXNzIHByaW9yIHdyaXR0ZW4gcGVybWlzc2lvbiBpcyBvYnRhaW5lZCAtLT4NCjwhLS0gZnJvbSBYbmdhZ2UgTExDLiAtLT4NCjwhLS0gLS0+DQoNCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0zOS41IDEwLjM3SDYuMjNMMTQuMyAyLjMgMTIgMCAwIDEybDEyIDEyIDIuMy0yLjMtOC4wNy04LjA3SDM5LjV6Ii8+PC9zdmc+";

const arrowIcons = css`
    &__next-button {
        background-image: url("${`data:image/svg+xml;base64,${chevronRightString}`}");
    }
    &__prev-button {
        background-image: url("${`data:image/svg+xml;base64,${chevronLeftString}`}");
    }
`;

export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        dateTimePickerProps: {
            showNeighboringMonth: true,
        },
        cssOverrides: {
            datePicker: css`
                button:focus {
                    /* outline is added on span for border reasons */
                    outline: none;
                    span {
                        outline: none;
                    }
                }

                .react-calendar {
                    width: 100%;
                    max-width: 280px; // to fix small mobile screen size issue
                    min-width: 245px;
                    border-radius: 2px 2px 0 0;
                    padding: 0;
                    right: 0;
                    left: unset;
                    button {
                        &:enabled {
                            &:hover:not(:disabled),
                            &:focus:not(:disabled) {
                                cursor: pointer;
                                color: ${color("common.ui18")};
                                background-color: ${color("common.white")};
                                &:not([class^="react-calendar__navigation__"]) {
                                    background-color: ${color("common.ui19")};
                                }
                            }
                        }
                    }

                    &__navigation {
                        padding: 12px 16px 18px;
                        border-radius: 2px 2px 0 0;
                        margin-bottom: 0;

                        button {
                            background-color: transparent;
                            min-width: 19px;
                            &:enabled {
                                &:hover:not(:disabled),
                                &:focus:not(:disabled) {
                                    cursor: pointer;
                                }
                            }
                        }
                        &__label {
                            font-size: 14px;
                            letter-spacing: 0.5px;
                            line-height: 16px;
                            color: ${color("common.ui10")};
                            background-color: transparent;
                        }
                        &__arrow {
                            width: 19px;
                            height: auto;
                        }
                    }

                    &__month-view {
                        &__weekdays {
                            color: ${color("common.ui8")};
                            font-size: 12px;
                            font-weight: 400;
                            letter-spacing: 0;
                            line-height: 13px;
                            padding-bottom: 8px;
                        }

                        &__days {
                            background-color: ${color("common.white")};

                            &__day {
                                cursor: pointer;
                                font-size: 14px;
                                padding: 8px 0;
                                margin: 0;
                            }
                        }
                    }

                    &__year-view {
                        button.react-calendar__year-view__months__month {
                            font-size: 14px;
                        }
                    }

                    &__tile {
                        &--hasActive:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth),
                        &--active:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth) {
                            background-color: ${color("common.ui19")};
                            color: ${color("common.ui18")};
                            font-weight: 600;
                        }
                        &--now {
                            font-weight: 600;
                        }
                    }
                }

                .react-datetime-picker__inputGroup input {
                    &,
                    &:focus,
                    &:hover {
                        border: none;
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
